import { ContaminationLevel } from '@common/enums';

type ColorSchema = {
    backgroundColor: string;
    borderColor: string;
};

export const ToxicLevelColorSchemas: Record<ContaminationLevel, ColorSchema> = {
    [ContaminationLevel.mrr]: {
        backgroundColor: '#b8f8c5',
        borderColor: '#3ee45c',
    },
    [ContaminationLevel.km]: {
        backgroundColor: '#b8c5f8',
        borderColor: '#577fbd',
    },
    [ContaminationLevel.mkm]: {
        backgroundColor: '#ffe24a',
        borderColor: '#e2e600',
    },
    [ContaminationLevel.inert]: {
        backgroundColor: 'rgba(67, 255, 156, 0.3)',
        borderColor: '#26e49f',
    },
    [ContaminationLevel.ifa]: {
        backgroundColor: '#fc944d',
        borderColor: '#f19847',
    },
    [ContaminationLevel.fa]: {
        backgroundColor: '#fa5353',
        borderColor: '#e81811',
    },
    [ContaminationLevel.limit]: {
        backgroundColor: 'rgba(247, 25, 18, 0.3)',
        borderColor: '#e81811',
    },
    [ContaminationLevel.na]: {
        backgroundColor: 'rgba(247, 25, 18, 0.3)',
        borderColor: '#e81811',
    },
};
